// extracted by mini-css-extract-plugin
module.exports = {"right":"ViewModes_right__26Bqg"};